import { writable, Writable } from 'svelte/store';

/**
 * Environment selection for the Janus4 builder preview iframe.
 *
 * The selected environment determines which janus4 deployment the builder
 * embeds: https://web-{env}-{tricode}-{league}.yinzcam.com
 *
 * The selection persists per-user in localStorage and defaults to prod.
 */
export type Janus4PreviewEnvironment = 'prod' | 'staging' | 'test';

export const JANUS4_PREVIEW_ENVIRONMENTS: Janus4PreviewEnvironment[] = ['prod', 'staging', 'test'];

const STORAGE_KEY = 'yc-builder-janus4-preview-env';
const DEFAULT_ENVIRONMENT: Janus4PreviewEnvironment = 'prod';

function loadStoredEnvironment(): Janus4PreviewEnvironment {
  try {
    const stored = window?.localStorage?.getItem(STORAGE_KEY) as Janus4PreviewEnvironment;
    if (JANUS4_PREVIEW_ENVIRONMENTS.includes(stored)) {
      return stored;
    }
  } catch (e) {
    // localStorage unavailable (e.g. blocked storage in iframe) - fall through
  }
  return DEFAULT_ENVIRONMENT;
}

export const janus4PreviewEnvironmentStore: Writable<Janus4PreviewEnvironment> = writable(loadStoredEnvironment());

janus4PreviewEnvironmentStore.subscribe((value) => {
  try {
    window?.localStorage?.setItem(STORAGE_KEY, value);
  } catch (e) {
    // localStorage unavailable - selection just won't persist
  }
});

export function getJanus4PreviewBaseUrl(environment: Janus4PreviewEnvironment): string {
  return `https://web-${environment}-${CONFIG.tricode}-${CONFIG.league}.yinzcam.com`;
}
